

import Vue from 'vue';
import CollectInForDialog from "./index.vue";

let CollectInForDialogVue = null;

/**
 * 创建新的vue实例
 * @param {*} param
 * @param { Object } param.info 要收集的信息内容
 * @param { Function } param.onSubmit 提交按钮的回调函数
 * @param { Function } param.onCancel 取消按钮的回调函数
 * @returns
 */
function create(info, { onSubmit = null, onCancel = null }) {
  const vnode = new Vue({
    render: h => h(CollectInForDialog, {
      props: {
        info
      },
      on: {
        submit: onSubmit,
        cancel: onCancel
      }
    }),
  }).$mount();

  document.body?.appendChild(vnode.$el);
  return vnode.$children[0];
}

/**
 * 展示收集信息
 * @param {*} args 参数
 * @param {*} cb 回调函数对象
 * @returns
 */
export function showCollectInForDialog(args, cb) {
  CollectInForDialogVue = null
  // object_id 转string
  const params = {
    ...args,
    object_id: String(args.object_id)
  }
  if (!CollectInForDialogVue) {
    CollectInForDialogVue = create(params, cb)
  }
  CollectInForDialogVue.show(params);
  return CollectInForDialogVue;
}

// 隐藏收集信息
export function hideCollectInForDialog(args) {
  if (!CollectInForDialogVue) return;
  CollectInForDialogVue.hide(args);
  return CollectInForDialogVue;
}


